'use strict'

const getCurrentUser = require('../security/browser/CurrentUser.js').getCurrentUser;

const modal = new (require('../helpers/modal'))
const pages = require('../templates/_index')
const ajax = require('../helpers/ajax')
const forms = new (require('../helpers/forms'))

module.exports = class {




	constructor(doc, article) {
		this._doc = doc
		this._article = article
		this._buildHeader()
	}

	_buildHeader() {

		this.defaultValues()

		this._container = document.createElement('div')
		this._container.className = 'editor'
		this._container.innerHTML = `
			<div class="buttons"></div>
			<a class="title"></a>
			<div class="tools"></div>
		`
		this._elemButtons = this._container.querySelector('.buttons')
		this._elemTitle = this._container.querySelector('.title')
		this._elemTools = this._container.querySelector('.tools')

		this.setTitle()
		this._actionButtons()

		let container = document.querySelector('#main')
		container.innerHTML = ''
		container.appendChild(this._container)
	}

	defaultValues() {
		if (!this._article) { return }
		if (!this._article.meta) { this._article.meta = {} }
		if (!this._article.meta.tags) { this._article.meta.tags = [] }
		if (!this._article.meta.title) { this._article.meta.title = '' }
	}

	_actionButtons() {

		// let space = document.createElement('span')
		// space.className = 'btn-space'

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:article-add')) {
			let add = document.createElement('button')
			add.innerHTML = '<i class="material-icons">add</i>'
			add.onclick = () => this.addPageModal()
			this._elemTools.appendChild(add)
		}

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:articles-manage')) {
			let list = document.createElement('button')
			list.innerHTML = '<i class="material-icons">reorder</i>'
			list.onclick = () => window.location = '/editor/articles'
			this._elemTools.appendChild(list)
		}

			let exit = document.createElement('button')
			exit.innerHTML = '<i class="material-icons">exit_to_app</i>'
			exit.onclick = () => {
				window.location = this._doc.defaultView.location.pathname
			}
			this._elemTools.appendChild(exit)

		// existing page edit
		if (!this._article) { return }

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-tags')) {
			let tags = document.createElement('button')
				tags.onclick = () => this.formTags()
			this.btnTags = tags
			this.btnTags.innerHTML = 'Tagy: ' +
				this._article.meta.tags.join(', ').trim()

			this._elemButtons.appendChild(tags)
		}


	}

	setTitle() {
		if (!this._article) { return }

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-title')) {
			const template = pages[this._article.meta.template]
			const from = new Date(this.toInputFormat(this._article.meta.from))
				.toLocaleDateString()
			if (!template) { return }

			this._elemTitle.innerHTML = `
				<span class="name">
				${this._article.meta.title || '(chýba nadpis)'}</span>
				Template: ${template.name} -
				${this._article.meta.enabled ? 'Verejný' : 'Privátny'} -
				${from}
			`
			this._elemTitle.onclick = () => this.formTitle()
		}
	}

	addPageModal() {
		const div = document.createElement('div')
		const ul = document.createElement('ul')
		ul.className = 'pagelist'
		div.appendChild(ul)
		Object.keys(pages).forEach(key => {
			const config = pages[key]
			const li = document.createElement('li')
			li.innerHTML = `<a>
				<span></span>
				<span class="preview">${config.preview}</span>
				<span class="name">${config.name}</span>
			</a>`
			ul.appendChild(li)
			li.querySelector('a').onclick = () => {

				function readCookie(name) {

					var nameEQ = name + "=";
					var ca = document.cookie.split(';');
					for(var i=0;i < ca.length;i++) {
					    var c = ca[i];
					    while (c.charAt(0)==' ') c = c.substring(1,c.length);
					    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
					}
					return null;
				}


				let currentUser = new getCurrentUser({
					name: name
				})




				const newArticle = {
					meta: {
						template: key,
						enabled: true,
						from: new Date().toISOString()
							.substr(0, 10).replace(/-/ig, ''),
						tags: config.defaultTags || [],
						security: config.defaultSecurity || {},
						author: currentUser.name || {}
					},
					data: config.defaultData || [],
				}

				ajax({
					method: 'PUT',
					url: '/api/article',
					dataType: 'application/json',
					data: newArticle,
				}).then(resp => {
					this._doc.location.pathname = '/article/-/' + resp.insertedIds[0]
				})

				modal.hide()
			}
		})
		modal.show('Vytvoriť novú stránku', div)
	}

	saveArticle() {
		return ajax({
			method: 'PUT',
			url: '/api/article',
			dataType: 'application/json',
			data: this._article,
		})
	}

	formTitle() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let title = document.createElement('input')
		title.value = this._article.meta.title || ''
		div.appendChild(forms.input('Nadpis', title))


		let enabled = document.createElement('input')
		enabled.type = 'checkbox'
		if (!this._article.meta.enabled) { this._article.meta.enabled = false }
		enabled.checked = this._article.meta.enabled
		enabled.onclick = () => {
			this._article.meta.enabled = enabled.checked
		}
		div.appendChild(forms.input('Verejný', enabled))

		let from = document.createElement('input')
		from.type = 'date'
		if (!this._article.meta.from) {
			this._article.meta.from =
				new Date().toISOString().substr(0, 10).replace(/-/ig, '')
		}
		from.value = this.toInputFormat(this._article.meta.from)
		from.onchange = () => {
			this._article.meta.from =
				new Date(from.valueAsDate)
					.toISOString().substr(0, 10).replace(/-/ig, '')
		}
		div.appendChild(forms.input('Zverejniť od', from))

		let sec_view_perms = document.createElement('input')
		if (this._article.meta.security && this._article.meta.security.read && Array.isArray(this._article.meta.security.read)) {
			sec_view_perms.value = this._article.meta.security.read.join()
		}
		div.appendChild(forms.input('Práva pre čítanie', sec_view_perms))

		let sec_write_perms = document.createElement('input')
		if (this._article.meta.security && this._article.meta.security.write && Array.isArray(this._article.meta.security.write)) {
			sec_write_perms.value = this._article.meta.security.write.join()
		}

		div.appendChild(forms.input('Práva pre zápis', sec_write_perms))

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._article.meta.title = title.value
			this._article.meta.security = {
				read: sec_view_perms.value.split(',')
					.map(v => v.trim())
					.filter(v => v.length > 1),
				write: sec_write_perms.value.split(',')
					.map(v => v.trim())
					.filter(v => v.length > 1)
			}
			this.saveArticle()
			modal.hide()
			this.setTitle()
		}
		block.appendChild(forms.actions(button))

		let formtitle = 'Nastavenia stránky'
		modal.show(formtitle, block).then(() => { title.focus() })

	}

	toInputFormat(str) {
		if (!str) { return }
		return [str.substr(0, 4), str.substr(4, 2), str.substr(6, 2)].join('-')
	}

	formTags() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let tag = document.createElement('input')
		if (!this._article.meta.tags) { this._article.meta.tags = [] }
		tag.value = this._article.meta.tags.join(', ')
		div.appendChild(forms.input('Tagy', tag))

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._article.meta.tags = tag.value.split(',')
			this._article.meta.tags = this._article.meta.tags.map(x => x.trim())

			this.saveArticle()
			modal.hide()
			this.btnTags.innerHTML = 'Tagy: ' +
				this._article.meta.tags.join(', ').trim()
		}
		block.appendChild(forms.actions(button))

		let title = 'Tagy stránky'
		modal.show(title, block).then(() => { tag.focus() })

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/editor/page.js
// module id = 270
// module chunks = 0